import { Box } from "@chakra-ui/react";
import React, { ReactNode } from "react";
import AdsCard from "./AdsCard";
import AdsCardHorizontal from "./AdsCardHorizontal";
import { MarkdownRender } from "./MarkdownRender";

function PostContentRender({ content, isMobileScreen, isSmallMobileScreen }: { content: string, isMobileScreen: boolean, isSmallMobileScreen:boolean }) {
  
  const renderPostSubtitleAds = (): ReactNode => {
    let count: number = 0;

    return content
      .split("\n")
      .map((line: string, index: number) => {
        if (line.trim().startsWith("## ")) {
          count += 1;
          if (count % 2 === 1 && count !== 1) {
            return (
              <React.Fragment key={index}>
                {!isMobileScreen && (
                  <AdsCard
                    slot="2097991556"
                    format="fluid"
                    layout="in-article"
                    h="148px"
                    style={{
                      display: "block",
                      textAlign: "center",
                      width: "100%",
                      height: "auto",
                    }}
                  />
                )}
                {isMobileScreen && !isSmallMobileScreen && (
                  <AdsCardHorizontal
                    slot="2097991556"
                    format="fluid"
                    layout="in-article"
                    h="auto"
                    style={{
                      display: "block",
                      textAlign: "center",
                      width: "100%",
                      height: "60px",
                    }}
                    p="0px 0px 16px 0px"
                  />
                )}
                <MarkdownRender>{line}</MarkdownRender>
              </React.Fragment>
            );
          } else {
            return <MarkdownRender key={index}>{line}</MarkdownRender>;
          }
        } else {
          return <MarkdownRender key={index}>{line}</MarkdownRender>;
        }
      });
  };

  return (
    <>
      <Box className="article" padding="0 32px 0 32px">
        {
          renderPostSubtitleAds()
          }
      </Box>
    </>
  );
}

export default PostContentRender;